<script setup lang="ts">
/**
 * Marketing Site App Root Component
 */
import { ToastBridge } from '@claimshield/shared'
import UpdateAvailableBanner from '@/components/UpdateAvailableBanner.vue'
</script>

<template>
  <!-- Phones: the default 25rem toast is wider than a 390px screen and ran off its left edge. -->
  <PToast position="top-right" :baseZIndex="9999" :breakpoints="{ '480px': { width: 'calc(100vw - 40px)' } }" />
  <ToastBridge />
  <UpdateAvailableBanner />
  <RouterView />
</template>
